module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "设置小程序相关新信息！新增的服务器配置信息需要先在开放平台填写后再更新到指定小程序上",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "placeholder": "选择小程序"
    },
    on: {
      "change": _vm.wxappSelectHandle
    },
    model: {
      value: (_vm.check_wxappid),
      callback: function($$v) {
        _vm.check_wxappid = $$v
      },
      expression: "check_wxappid"
    }
  }, _vm._l((_vm.wx_appid_list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.handlefindList
    }
  }, [_vm._v("查看服务器设置")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看服务器设置",
      "visible": _vm.dialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    },
    model: {
      value: (_vm.getlist),
      callback: function($$v) {
        _vm.getlist = $$v
      },
      expression: "getlist"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "requestdomain"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "requestdomain"
    },
    model: {
      value: (_vm.getlist.requestdomain),
      callback: function($$v) {
        _vm.$set(_vm.getlist, "requestdomain", $$v)
      },
      expression: "getlist.requestdomain"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.editHandle('request')
      }
    }
  }, [_vm._v(" 更新requestdomain ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "wsrequestdomain"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "wsrequestdomain"
    },
    model: {
      value: (_vm.getlist.wsrequestdomain),
      callback: function($$v) {
        _vm.$set(_vm.getlist, "wsrequestdomain", $$v)
      },
      expression: "getlist.wsrequestdomain"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.editHandle('socket')
      }
    }
  }, [_vm._v(" 更新wsrequestdomain ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "uploaddomain"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "uploaddomain"
    },
    model: {
      value: (_vm.getlist.uploaddomain),
      callback: function($$v) {
        _vm.$set(_vm.getlist, "uploaddomain", $$v)
      },
      expression: "getlist.uploaddomain"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.editHandle('uploadFile')
      }
    }
  }, [_vm._v(" 更新uploaddomain ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "downloaddomain"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "downloaddomain"
    },
    model: {
      value: (_vm.getlist.downloaddomain),
      callback: function($$v) {
        _vm.$set(_vm.getlist, "downloaddomain", $$v)
      },
      expression: "getlist.downloaddomain"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.editHandle('downloadFile')
      }
    }
  }, [_vm._v(" 更新downloaddomain ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "invalid_requestdomain"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "invalid_requestdomain"
    },
    model: {
      value: (_vm.getlist.invalid_requestdomain),
      callback: function($$v) {
        _vm.$set(_vm.getlist, "invalid_requestdomain", $$v)
      },
      expression: "getlist.invalid_requestdomain"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "invalid_wsrequestdomain"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "invalid_wsrequestdomain"
    },
    model: {
      value: (_vm.getlist.invalid_wsrequestdomain),
      callback: function($$v) {
        _vm.$set(_vm.getlist, "invalid_wsrequestdomain", $$v)
      },
      expression: "getlist.invalid_wsrequestdomain"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "invalid_uploaddomain"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "invalid_uploaddomain"
    },
    model: {
      value: (_vm.getlist.invalid_uploaddomain),
      callback: function($$v) {
        _vm.$set(_vm.getlist, "invalid_uploaddomain", $$v)
      },
      expression: "getlist.invalid_uploaddomain"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "invalid_uploaddomain"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "invalid_downloaddomain"
    },
    model: {
      value: (_vm.getlist.invalid_downloaddomain),
      callback: function($$v) {
        _vm.$set(_vm.getlist, "invalid_downloaddomain", $$v)
      },
      expression: "getlist.invalid_downloaddomain"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4a1bf415", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a1bf415"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/setting_domain.vue
// module id = 2685
// module chunks = 0